// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___2yeQU","btnLine":"style__btnLine___3XQb4","btn":"style__btn___2R-wM","btnLink":"style__btnLink___2VLYs","btnCancel":"style__btnCancel___AatGT","btnDelete":"style__btnDelete___1NnJB","modal":"style__modal___1bDIo","require-tag":"style__require-tag___kEwXY","group-editor":"style__group-editor___19boI"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/style.scss
// module id = 1786
// module chunks = 0